import { HttpClient } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Observable, tap } from 'rxjs';
import {
    FedExShipmentResponseViewModel,
    FedExShipmentViewModel,
} from '../models/fedex-shipment.model';
import { ShipmentStore } from '@pf/platform-wms/domain';

export const CPW_BFF_URL = new InjectionToken<string>('CPW_BFF_URL');

@Injectable({ providedIn: 'root' })
export class CpwBackendService {
    private shipmentStore = inject(ShipmentStore);
    private httpClient = inject(HttpClient);
    private readonly bffUrl = inject(CPW_BFF_URL);
    private metabaseUrl = `${this.bffUrl}/api/metabase/embed`;
    private createFedExShipmentUrl = `${this.bffUrl}/api/sdi/fedex/ship`;

    getEmbedToken(dashboardSlug: string): Observable<string> {
        return this.httpClient.get(this.metabaseUrl, {
            params: { dashboard: dashboardSlug },
            responseType: 'text',
        });
    }

    createFedExShipment$(
        request: FedExShipmentViewModel
    ): Observable<FedExShipmentResponseViewModel> {
        return this.httpClient
            .post<FedExShipmentResponseViewModel>(
                this.createFedExShipmentUrl,
                request
            )
            .pipe(
                tap(response => {
                    const shipment = this.shipmentStore.get(request.shipmentId);
                    if (shipment) {
                        shipment.trackingNumber = response.trackingNumber;
                        this.shipmentStore.update(shipment);
                    }
                })
            );
    }
}
